import Actions from "./actions";
import Cells from "./cells";
import Columns from "./columns";
import Cell from "./cell";
import RowSelection from "./row-selection";
import { getIdFromTableRow } from "../helpers/table";
import { EventConstants } from "../constants";
import ServiceContainer from "../modules/service-container";
export default class Table {
    constructor(el, services) {
        this.el = el;
        this.AcServices = services;
        this.Services = new ServiceContainer();
        this.Columns = new Columns(el);
        this.Cells = new Cells();
        this.Actions = document.getElementById('ac-table-actions') ? new Actions(document.getElementById('ac-table-actions')) : null;
        this.Selection = new RowSelection(this);
    }
    getElement() {
        return this.el;
    }
    getIdsFromTable() {
        let result = [];
        this.el.getElementsByTagName('tbody')[0].querySelectorAll('tr').forEach(row => {
            result.push(getIdFromTableRow(row));
        });
        return result;
    }
    init() {
        this.initTable();
        this.addCellClasses();
        document.dispatchEvent(new CustomEvent('AC_Table_Ready', { detail: { table: this } }));
        this.AcServices.emitEvent(EventConstants.TABLE.READY, { table: this });
        return this;
    }
    addCellClasses() {
        this.Columns.getColumnNames().forEach((name) => {
            let type = this.Columns.get(name).type;
            let cells = this.Cells.getByName(name);
            cells.forEach((cell) => {
                cell.getElement().classList.add(type);
            });
        });
    }
    initTable() {
        this.el.getElementsByTagName('tbody')[0].querySelectorAll('tr').forEach(row => {
            this.updateRow(row);
        });
    }
    updateRow(row) {
        let id = getIdFromTableRow(row);
        row.dataset.id = id.toString();
        this.setCellsForRow(row);
    }
    setCellsForRow(row) {
        let id = getIdFromTableRow(row);
        this.Columns.getColumnNames().forEach((name) => {
            let selector = name.replace(/\./g, '\\.');
            let td = row.querySelector("td.column-" + selector);
            if (td) {
                let cell = new Cell(id, name, td);
                this.Cells.add(id, cell);
            }
        });
    }
}
